export default {
    groupName: 'comcast',
    appName: 'Comcast',
    baseRoute: '/dashboard/comcast',
    label: 'Ad Tracker Dashboard',
    home: '/slicer',
    image: 'comcast.png',
    description: 'Comcast Advertising Dashboard'
}